import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import ShowNotificationSettings from './ShowNotificationSettings';
import { NOTIFICATION_SETTINGS_PATH } from './routes/routePaths';

export default function Routes() {
  return (
    <Switch>
      <Route exact path={NOTIFICATION_SETTINGS_PATH} component={ShowNotificationSettings} />
      <Redirect to={NOTIFICATION_SETTINGS_PATH} />
    </Switch>
  );
}
